import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import ButtonLink from 'components/ButtonLink'
import ROUTES from 'config/routes.json'
import useIsAuthPage from 'hooks/useIsAuthPage'
import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

function LoggedOut() {
  const isAuthPage = useIsAuthPage()
  const t = getTranslationFromJson([content])

  const handleButtonClick = (eventName: string) => {
    nextTick().then(() => {
      trackEvent(eventName)
    })
  }

  return (
    isAuthPage === false && (
      <div className={classes.buttonsContainer}>
        <ButtonLink
          href={ROUTES.LOGIN}
          size='small'
          className={classes.headerLink}
          data-test='header-login-btn'
          onClick={() => handleButtonClick('header_login_button_click')}
        >
          {t('login')}
        </ButtonLink>

        <ButtonLink
          href={ROUTES.REGISTER}
          size='small'
          className={classes.headerLink}
          data-test='header-register-btn'
          onClick={() => handleButtonClick('header_register_button_click')}
        >
          {t('register')}
        </ButtonLink>
      </div>
    )
  )
}

export default LoggedOut
